<template>
  <section>
    <Header />

    <div class="slider-area fix p-relative">
      <div class="slider-active swiper-container h-100">
        <swiper
          ref="mySwiper"
          :modules="modules"
          :effect="'fade'"
          :loop="true"
          :navigation="{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }"
          :autoplay="{ delay: 5000 }"
        >
          <swiper-slide v-for="item in sliderData" :key="item.id">
            <div
              class="slider-list slider-height-2 swiper-slide d-flex align-items-center pt-70"
            >
              <div
                class="slider-bg img-zoom"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/img/slider/' + item.img) + ')',
                  backgroundPosition: bottom,
                }"
              ></div>
              <div class="container p-relative">
                <div class="row h-100">
                  <div class="col-12 position-relative">
                    <div class="slider-text slider-text-2 z-index">
                      <h2 class="slider-title" v-html="item.title"></h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <!-- If we need pagination -->
        <!-- <div class="swiper-pagination"></div> -->

        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev sp-arrow">
          <vue-feather
            size="24"
            stroke="white"
            type="chevron-left"
          ></vue-feather>
        </div>
        <div class="swiper-button-next sp-arrow">
          <vue-feather
            size="24"
            stroke="white"
            type="chevron-right"
          ></vue-feather>
        </div>
      </div>

      <b-row class="conOfSliderBtns m-0">
        <b-col md="4" cols="12" class="p-0">
          <div class="slider-btn" @click="showComponent(1)">
            <div class="d-flex align-items-center">
              المؤسسات
              <vue-feather
                size="24"
                stroke="white"
                type="chevron-left"
              ></vue-feather>
            </div>
            <div class="slider-txt">
              سجّل شركتك الآن وموظفيك لدينا لتكن وسط كبرى الشركات في المملكة
              العربية السعودية لزيادة فرص التعاون بين الشركات والوزارات لكبرى
              المشاريع
            </div>
          </div>
        </b-col>
        <b-col md="4" cols="12" class="p-0">
          <div class="slider-btn" @click="showComponent(2)">
            <div class="d-flex align-items-center">
              الوزارة
              <vue-feather
                size="24"
                stroke="white"
                type="chevron-left"
              ></vue-feather>
            </div>
            <div class="slider-txt">
              نيساعد دليلنا للعثور على الشركات والمؤسسات في جميع أنحاء المملكة
              العربية السعودية حيث يعتبر مرجعك الموثوق للبحث عن الشركات السعودية
              في مختلف المجالات بدقة وبأسرع وقت
            </div>
          </div>
        </b-col>
        <b-col md="4" cols="12" class="p-0">
          <div class="slider-btn" @click="showComponent(3)">
            <div class="d-flex align-items-center">
            مراكز التدريب
              <vue-feather
                size="24"
                stroke="white"
                type="chevron-left"
              ></vue-feather>
            </div>

            <div class="slider-txt">
              بانضمامك لنا ستزيد فرص تواجدك بين أكبر الشركات والمؤسسات في جميع
              أنحاء المملكة العربية والسعودية
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row class="m-0">
      <News v-if="showNews" />
      <LoginMinistry v-if="showMinistry" />
      <AuthCompanies v-if="showCompanies" />
      <TrainingCompanies v-if="showTrainingCompanies" />
    </b-row>
    <Footer />
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, EffectFade, Autoplay } from "swiper";
import LoginMinistry from "./components/LoginMinistry.vue";
import AuthCompanies from "./components/AuthCompanies/index.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import News from "@/components/common/news.vue";
import TrainingCompanies from "./components/trainingCompanis/Companies.vue";

export default {
  name: "HomeTwoSlider",
  components: {
    LoginMinistry,
    AuthCompanies,
    Swiper,
    SwiperSlide,
    Header,
    Footer,
    News,
    TrainingCompanies,
  },
  data() {
    return {
      showNews: true,
      showMinistry: false,
      showCompanies: false,
      showTrainingCompanies: false,

      sliderData: [
        {
          id: "1",
          img: "bg1.jpg",
          title: "نظام الشهادات ",
        },
        {
          id: "2",
          img: "bg2.jpg",
          title: "نظام منح الشهادات ",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Navigation, EffectFade, Autoplay],
    };
  },
  methods: {
    showComponent(componentNumber) {
      // Reset all flags
      this.showMinistry = false;
      this.showCompanies = false;
      this.showTrainingCompanies = false;
      this.showNews = false;
      // Set the flag for the clicked component
      if (componentNumber === 2) {
        this.showMinistry = true;
      } else if (componentNumber === 1) {
        this.showCompanies = true;
      } else if (componentNumber === 3) {
        this.showTrainingCompanies = true;
      }
    },
  },
};
</script>
